const DEFAULT_MAX_EDGE = 2400;

function readCanvasBlob(canvas, type, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Unable to prepare the cropped image."));
          return;
        }

        resolve(blob);
      },
      type,
      quality
    );
  });
}

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Unable to read the cropped image."));
    reader.readAsDataURL(blob);
  });
}

export async function cropImageToDataUrl(
  image,
  pixelCrop,
  options = {}
) {
  const { maxEdge = DEFAULT_MAX_EDGE, type = "image/jpeg", quality = 0.92 } =
    options;

  if (!image || !pixelCrop?.width || !pixelCrop?.height) {
    throw new Error("Choose a crop before publishing.");
  }

  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  const cropWidth = pixelCrop.width * scaleX;
  const cropHeight = pixelCrop.height * scaleY;
  const outputScale =
    Math.min(1, maxEdge / Math.max(cropWidth, cropHeight)) || 1;

  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(cropWidth * outputScale));
  canvas.height = Math.max(1, Math.round(cropHeight * outputScale));

  const context = canvas.getContext("2d");

  if (!context) {
    throw new Error("Unable to prepare the image canvas.");
  }

  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = "high";
  context.drawImage(
    image,
    pixelCrop.x * scaleX,
    pixelCrop.y * scaleY,
    cropWidth,
    cropHeight,
    0,
    0,
    canvas.width,
    canvas.height
  );

  const blob = await readCanvasBlob(canvas, type, quality);
  return blobToDataUrl(blob);
}

export function revokeObjectUrl(objectUrl) {
  if (objectUrl) {
    URL.revokeObjectURL(objectUrl);
  }
}
